import { useEffect, useRef, useState } from 'react';

export const useNetworkDisconnection = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  // Tracks whether we've actually seen a real drop, so we don't reload on
  // the initial mount (which is also an "online" transition as far as the
  // browser's event goes).
  const wasOffline = useRef(false);

  useEffect(() => {
    const handleOffline = () => {
      wasOffline.current = true;
      setIsOnline(false);
    };

    const handleOnline = () => {
      setIsOnline(true);
      // A full reload (not just a component re-render) so every page's data
      // fetch runs fresh against the API once connectivity is actually back.
      if (wasOffline.current) {
        window.location.reload();
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  return isOnline;
};
